
export const STORE_SOLACE_CREDENTIALS = `STORE_SOLACE_CREDENTIALS`

export const storeSolaceCredentials = (payload:any): any => {
	return {
		type: STORE_SOLACE_CREDENTIALS,
		payload
	}
}